import { useQuery } from "@tanstack/react-query";

import { type AppRelease } from "@fitness-app/data-models";

import { supabase } from "~/store/initializeStore";

export const APP_RELEASES_QUERY_KEY = "appReleases";

// Pickable app releases for the "fixed in version" select — rows are recorded
// automatically whenever /app-config is saved with a changed current version.
export const useAppReleases = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: [APP_RELEASES_QUERY_KEY],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("app_release")
        .select()
        .order("releasedAt", { ascending: false });

      if (error) {
        throw error;
      }

      return (data || []) as AppRelease[];
    },
  });

  return { releases: data || [], isLoading, isError };
};
